import { useRef } from "react";
import { resolveSrc } from "@/context/AdminContext";

const FALLBACK_POSTER = "/ad-poster-fallback.jpg";

export const AdPlayer = ({ ad, index }) => {
  const videoRef = useRef(null);

  const handleEnter = () => {
    const v = videoRef.current;
    if (!v) return;
    v.muted = false;
    const p = v.play();
    if (p && p.catch) p.catch(() => {});
  };

  const handleLeave = () => {
    const v = videoRef.current;
    if (!v) return;
    v.pause();
  };

  const posterUrl = ad.poster ? resolveSrc(ad.poster) : FALLBACK_POSTER;

  return (
    <div
      className="group relative rounded-2xl border border-white/10 bg-[#0a0a0a] transition-transform duration-500 hover:scale-[1.008]"
      data-testid={`concept-${index + 1}`}
    >
      <div
        className="relative flex aspect-video w-full overflow-hidden rounded-t-2xl bg-black"
        onMouseEnter={handleEnter}
        onMouseLeave={handleLeave}
      >
        <video
          ref={videoRef}
          loop
          playsInline
          preload="metadata"
          poster={posterUrl}
          className="h-full w-full bg-black object-contain"
          data-testid={`concept-video-${index + 1}`}
        >
          <source src={resolveSrc(ad.src)} type="video/mp4" />
        </video>
      </div>

      {/* video type (big) + title (small) BELOW the video */}
      <div className="flex flex-col gap-2 px-6 py-6 sm:px-8">
        <p className="text-xs uppercase tracking-[0.2em] text-white/50">
          {String(index + 1).padStart(2, "0")} — {ad.title}
        </p>
        <h3 className="font-anton text-3xl leading-none tracking-tightest sm:text-5xl">
          {ad.subtitle || "Motion Concept"}
        </h3>
      </div>
    </div>
  );
};
